import Link from "next/link";

import { HOMEPAGE } from "~/lib/homepage";
import NccaAccreditedProgramMark from "~/pages/exam-portal/components/NccaAccreditedProgramMark";

/** Homepage hero announcement — NCCA mark sits with exam copy only. */
const HomeNccaAnnouncement = () => {
	return (
		<div className="mx-auto flex max-w-3xl flex-col items-center gap-3 rounded-xl border border-white/25 bg-black/45 px-4 py-3 text-center text-white backdrop-blur-md sm:flex-row sm:items-center sm:gap-4 sm:px-5 sm:text-left">
			<NccaAccreditedProgramMark size="sm" />
			<div className="flex flex-col gap-2 text-sm sm:text-base">
				<p className="text-white">{HOMEPAGE.announcementText}</p>
				<Link
					href={HOMEPAGE.announcementHref}
					className="font-semibold text-sky-300 underline-offset-2 hover:underline"
				>
					{HOMEPAGE.announcementLinkLabel}
				</Link>
				<Link
					href={HOMEPAGE.cptProgramsHref}
					className="font-semibold text-sky-300 underline-offset-2 hover:underline"
				>
					{HOMEPAGE.cptProgramsLinkLabel}
				</Link>
			</div>
		</div>
	);
};

export default HomeNccaAnnouncement;
